import React, { forwardRef } from "react"
import Form from "react-bootstrap/Form"

const FormFieldText = forwardRef(
  (
    {
      id,
      name,
      label,
      placeholder,
      required,
      description,
      disabled,
      defaultValue,
      errorMsg,
      isInvalid,
      type,
      ...props
    },
    ref
  ) => {
    return (
      <Form.Group>
        <Form.Label htmlFor={id}>
          {label} {required && <>*</>}
        </Form.Label>
        <Form.Control
          name={name}
          id={id}
          type={type}
          placeholder={placeholder}
          defaultValue={defaultValue}
          disabled={disabled}
          isInvalid={isInvalid}
          ref={ref}
          {...props}
        />
        {errorMsg && isInvalid && (
          <Form.Text className="invalid-feedback">{errorMsg}</Form.Text>
        )}
        {description && (
          <Form.Text className="text-muted">{description}</Form.Text>
        )}
      </Form.Group>
    )
  }
)

export default FormFieldText

FormFieldText.defaultProps = {
  type: "text",
}
